import {
    createReducer,
    createActionResources
  } from "redux-waiters";
  import { RESET_REDUCER } from "../constants";
  
  export const fetchVideoStatisticsAction = createActionResources("video-statistics/fetch");
  export const fetchVideoStatsAggAction = createActionResources("video-statistics/fetchStatsAgg");
  
  const initialState = {
    fetching: false,
    videoStats: [],
    total: 0,
    totalPages: 0,
    pageNumber: 1,
    error: {},
  };
  
  export default createReducer(
    {
      [fetchVideoStatisticsAction.start]: state => {
        return { ...state, fetching: true };
      },
      [fetchVideoStatisticsAction.success]: (state, action) => {
        return {
          ...state,
          videoStats: action.data?.content,
          pageNumber: action.data?.pageNumber + 1,
          total: action.data?.total,
          totalPages: Math.ceil(action.data?.total / action.data?.pageSize),
          fetching: false,
        };
      },
      [fetchVideoStatisticsAction.error]: state => {
        return { ...state, fetching: false };
      },
  
      [RESET_REDUCER]: () => initialState,
    },
    initialState
  );
  